import React, { useState } from "react";
import getTranslationData from "../../../TranslationUtility/TranslationUtility";
import { useCheckoutContext } from "../context/CheckoutContext";

const AccordionItem = ({ label, open, onToggle, children }) => (
  <>
    <div
      className="item py-3"
      onClick={onToggle}
      style={{ cursor: "pointer" }}
    >
      <div className="text">{label}</div>
      <div className="arrow" onClick={onToggle}>
        <i className={`fa-solid ${open ? "fa-angle-down" : "fa-angle-right"}`}></i>
      </div>
    </div>
    {open && (
      <div
        className="mt-2 mx-2 pd-left"
        style={{ overflowWrap: "break-word" }}
        dangerouslySetInnerHTML={{ __html: children || "" }}
      />
    )}
  </>
);

const ProductInfoAccordions = () => {
  const translation = getTranslationData();
  const { productReducer } = useCheckoutContext();

  const [openInst, setOpenInst] = useState(false);
  const [openRedeem, setOpenRedeem] = useState(false);
  const [openTermsCon, setOpenTermsCon] = useState(false);
  const [openNote, setOpenNote] = useState(false);

  const disc = productReducer?.productReducerDisocount;

  return (
    <div className="tnc_redeem_note_box mt-3 jlkkedit2">
      <AccordionItem
        label={translation?.importantInstructions}
        open={openInst}
        onToggle={() => setOpenInst(!openInst)}
      >
        {disc?.instructionsContent}
      </AccordionItem>

      <AccordionItem
        label={translation?.how_to_use}
        open={openRedeem}
        onToggle={() => setOpenRedeem(!openRedeem)}
      >
        {disc?.howToUseContent}
      </AccordionItem>

      <AccordionItem
        label={translation?.terms_condition}
        open={openTermsCon}
        onToggle={() => setOpenTermsCon(!openTermsCon)}
      >
        {disc?.tncContent}
      </AccordionItem>

      <div
        className="item py-3"
        onClick={() => setOpenNote(!openNote)}
        style={{ cursor: "pointer" }}
      >
        <div className="text">{translation?.note}</div>
        <div className="arrow" onClick={() => setOpenNote(!openNote)}>
          <i className={`fa-solid ${openNote ? "fa-angle-down" : "fa-angle-right"}`}></i>
        </div>
      </div>
      {openNote && (
        <div className="mt-2 mx-2 d-flex pd-left">
          <span className="checkterm1">{translation?.demoBomText}</span>
        </div>
      )}
    </div>
  );
};

export default ProductInfoAccordions;
